var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_526_24954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.106445,
    y: 0.0390625,
    width: 20.8082,
    height: 20.8082,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_526_24954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M9.38332 15.125H11.6809V9.57613H9.38332V15.125ZM10.5066 7.49531C10.8126 7.49531 11.0704 7.39181 11.2799 7.18481C11.4894 6.97783 11.5942 6.72134 11.5942 6.41534C11.5942 6.10936 11.4907 5.8516 11.2837 5.64208C11.0767 5.43255 10.8202 5.32778 10.5142 5.32778C10.2082 5.32778 9.95049 5.43128 9.74096 5.63828C9.53143 5.84527 9.42667 6.10176 9.42667 6.40775C9.42667 6.71374 9.53017 6.97149 9.73717 7.18102C9.94415 7.39054 10.2006 7.49531 10.5066 7.49531ZM10.5104 19.8068C9.21512 19.8068 7.99784 19.561 6.85859 19.0695C5.71934 18.5779 4.72834 17.9107 3.88561 17.068C3.04288 16.2252 2.37571 15.2342 1.88412 14.095C1.39253 12.9557 1.14673 11.7385 1.14673 10.4431C1.14673 9.14413 1.39295 7.92337 1.8854 6.78087C2.37785 5.63835 3.04617 4.64453 3.89036 3.7994C4.73455 2.95425 5.72554 2.28964 6.86331 1.80556C8.00109 1.32148 9.21679 1.07944 10.5104 1.07944C11.8093 1.07944 13.0299 1.32148 14.1723 1.80556C15.3147 2.28964 16.3086 2.95435 17.1539 3.79968C17.9992 4.64501 18.6639 5.63906 19.148 6.78182C19.6321 7.9246 19.8741 9.14564 19.8741 10.4449C19.8741 11.7443 19.6321 12.9611 19.148 14.0954C18.6639 15.2298 17.9993 16.219 17.1542 17.0632C16.309 17.9074 15.3152 18.5757 14.1727 19.0682C13.0302 19.5606 11.8094 19.8068 10.5104 19.8068ZM10.5104 17.5093C12.4831 17.5093 14.1539 16.8247 15.523 15.4557C16.892 14.0866 17.5766 12.4158 17.5766 10.4431C17.5766 8.47051 16.892 6.79966 15.523 5.43061C14.1539 4.06155 12.4831 3.37701 10.5104 3.37701C8.5378 3.37701 6.86695 4.06155 5.4979 5.43061C4.12884 6.79966 3.4443 8.47051 3.4443 10.4431C3.4443 12.4158 4.12884 14.0866 5.4979 15.4557C6.86695 16.8247 8.5378 17.5093 10.5104 17.5093Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5393f0d212423d8f881f074ae2874232.svg";
export { ForwardRef as ReactComponent };